const videoPlayOverlays = new WeakSet();

function syncVideoPlayOverlay(wrapper, video) {
  wrapper.classList.toggle('is-playing', !video.paused && !video.ended);
}

function setupVideoPlayOverlay(wrapper) {
  if (videoPlayOverlays.has(wrapper)) return;

  const video = wrapper.querySelector('video');
  const button = wrapper.querySelector('[data-seal-video-play-button]');

  if (!video || !button) return;

  videoPlayOverlays.add(wrapper);

  button.addEventListener('click', () => {
    if (video.paused || video.ended) {
      video.play().catch(() => {});
    } else {
      video.pause();
    }
  });

  ['play', 'playing', 'pause', 'ended', 'loadedmetadata'].forEach((eventName) => {
    video.addEventListener(eventName, () => syncVideoPlayOverlay(wrapper, video));
  });

  syncVideoPlayOverlay(wrapper, video);
}

function setupVideoPlayOverlays(root = document) {
  root.querySelectorAll('[data-seal-video-play]').forEach(setupVideoPlayOverlay);
}

setupVideoPlayOverlays();

document.addEventListener('shopify:section:load', (event) => {
  setupVideoPlayOverlays(event.target);
});

const videoPlayOverlayObserver = new MutationObserver((records) => {
  records.forEach((record) => {
    record.addedNodes.forEach((node) => {
      if (!(node instanceof Element)) return;

      if (node.matches('[data-seal-video-play]')) {
        setupVideoPlayOverlay(node);
      }

      setupVideoPlayOverlays(node);
    });
  });
});

videoPlayOverlayObserver.observe(document.documentElement, {
  childList: true,
  subtree: true,
});
